/* eslint-disable import/no-default-export */
import HeartWrapper from './Heart/HeartWrapper';

export { HeartWrapper };
export default HeartWrapper;
